import clsx from 'clsx'
import {HeaderUserMenu} from '../../../partials'
import {useAuth} from '../../../../app/modules/auth'
import {useEffect, useRef, useState} from 'react'
import {collection, doc, DocumentReference, onSnapshot, query, where} from 'firebase/firestore'
import db from '../../../../services/firebase'
import useCrispChat from 'app/Hooks/useCrispChat'

declare global {
  interface Window {
    $crisp: any[]
    CRISP_WEBSITE_ID: string
  }
}

const itemClass = 'ms-1 ms-md-1'
const itemClass2 = 'ms-0 ms-md-0'
const btnClass = 'btn btn-sm btn-active-light btn-active-color-primary  h-35px help-button d-flex align-items-center'
const btnClass2 = 'btn btn-active-light btn-active-color-primary h-35px px-3 py-2'
const userAvatarClass = 'symbol-32px'

const iconStyles = {
  transition: 'stroke 0.3s ease',
}

const Navbar = () => {
  const {currentUser} = useAuth()
  const [avatarUrl, setAvatarUrl] = useState<string | undefined>(undefined)
  const [isChecked, setIsChecked] = useState(false)
  const [isDropdownVisible, setIsDropdownVisible] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const {toggleCrispChat} = useCrispChat()

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible)
  }

  const handleOptionClick = () => {
    setIsDropdownVisible(false)

    window.location.href = 'mailto:support@getsecureslate.com'
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownVisible(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef])

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    const tenantRef = doc(db, 'tenants', tenantId)
    const settingRef: DocumentReference = doc(tenantRef, 'settings', 'secureslate_ai')

    const unsubscribe = onSnapshot(settingRef, (snapshot) => {
      const data = snapshot.data()
      if (data) {
        setIsChecked(data.two_factor_enable)
      }
    })
    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    getPersonnel()
  }, [])

  const getPersonnel = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const uid = currentUser?.uid || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const employeesRef = collection(tenantRef, 'employees')

      const unsubscribe = onSnapshot(query(employeesRef, where('uid', '==', uid)), (snapshot) => {
        if (snapshot.docs.length > 0) {
          const employeeData = snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
            image_url: doc.data().image_url || doc.data().photo_url,
          }))
          setAvatarUrl(employeeData[0].image_url)
        } else {
          setAvatarUrl(undefined)
        }
      })
      return unsubscribe
    } catch (error) {
      console.error('Error getting personnel:', error)
    }
  }

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div> */}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div> */}

      {isChecked && currentUser?.role === 'Owner' && (
        <div className={clsx('app-navbar-item', itemClass2)}>
          <div className={clsx('position-relative')} id='kt_drawer_chat_toggle'>
            <a href='/chatgpt'>
              {' '}
              <button className={btnClass2}>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='#5A5A5A'
                  stroke-width='2'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  className='icon icon-tabler icons-tabler-outline icon-tabler-message me-1'
                >
                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                  <path d='M8 9h8' />
                  <path d='M8 13h6' />
                  <path d='M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z' />
                </svg>
                <span className='fs-6' style={{color: '#5A5A5A'}}>
                  {' '}
                  AI Chat
                </span>
              </button>
            </a>
          </div>
        </div>
      )}

      <div className={clsx('app-navbar-item', itemClass2)}>
        <div className='dropdown mx-2' ref={dropdownRef}>
          <div className={`${btnClass} ${isDropdownVisible ? 'active' : ''}`} onClick={toggleDropdown}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#5E6274'
              stroke-width='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-help help-icon me-1'
              style={iconStyles}
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0' />
              <path d='M12 17l0 .01' />
              <path d='M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4' />
            </svg>
            <span className='fs-6'>Help</span>
          </div>
          {isDropdownVisible && (
            <ul
              className='dropdown-menu show'
              style={{
                position: 'absolute',
                inset: '0px auto auto 0px',
                margin: '0px',
                transform: 'translate3d(0px, 40px, 0px)',
                marginLeft: '-50px',
              }}
            >
              <li>
                <button
                  className='dropdown-item fw-semibold fs-6 text-hover-primary d-flex align-items-center'
                  onClick={() => handleOptionClick()}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-mail me-2'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z' />
                    <path d='M3 7l9 6l9 -6' />
                  </svg>{' '}
                  Email
                </button>
              </li>
              <li>
                <button
                  className='dropdown-item fw-semibold fs-6 text-hover-primary d-flex align-items-center'
                  onClick={() => toggleCrispChat()}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-message me-2'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M8 9h8' />
                    <path d='M8 13h6' />
                    <path d='M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z' />
                  </svg>{' '}
                  Live Chat
                </button>
              </li>
              <li>
                <button
                  className='dropdown-item fw-semibold fs-6 text-hover-primary d-flex align-items-center'
                  onClick={() => window.open('https://help.getsecureslate.com', '_blank')}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-info-square-rounded me-2'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M12 9h.01' />
                    <path d='M11 12h1v4h1' />
                    <path d='M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z' />
                  </svg>{' '}
                  Help Center
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
      {/* {currentUser?.role === 'Admin' && (
        <div className={clsx('app-navbar-item', itemClass2)}>
          <div
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            className={btnClass}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#5E6274'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-bell btnIconClass help-icon'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6' />
              <path d='M9 17v1a3 3 0 0 0 6 0v-1' />
            </svg>
          </div>
          <HeaderNotificationsMenu />
        </div>
      )} */}
      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div> */}

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          {avatarUrl && avatarUrl !== '/media/svg/avatars/blank.svg' ? (
            <img
              alt='User avatar'
              loading='lazy'
              className='symbol-32px'
              src={avatarUrl}
              onError={(e) => {
                setAvatarUrl(undefined)
              }}
            />
          ) : (
            <div className='symbol symbol-32px'>
              <span className='symbol-label fs-6 fw-bold' style={{backgroundColor: '#F5F5F5'}}>
                {currentUser?.userName
                  ? `${currentUser?.userName.split(' ')[0]?.charAt(0).toUpperCase()}`
                  : ''}
              </span>
            </div>
          )}
        </div>
        {/* <div className='mx-2'>
          <span style={{display: 'block', fontSize: '12px'}} className='fw-bold '>
            {currentUser?.userName}
          </span>
          <span
            style={{color: '#5A5A5A', display: 'block', fontSize: '12px'}}
            className='fw-semibold'
          >
            Admin
          </span>
        </div> */}
        <HeaderUserMenu />
      </div>

      {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )} */}
    </div>
  )
}
const style = document.createElement('style')
style.textContent = `
  .help-button {
    transition: background-color 0.3s ease;
  }
  .help-button:hover,
  .help-button.active {
    background-color: #E8FFF8 !important;
  }
  .help-button:hover .help-icon,
  .help-button.active .help-icon {
    stroke: #0E9F6E;
  }
`
document.head.appendChild(style)
export {Navbar}
